import React, { createContext, useContext, useState } from 'react';

const ImpersonationContext = createContext();

export const useImpersonation = () => {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error('useImpersonation must be used within an ImpersonationProvider');
  }
  return context;
};

export const ImpersonationProvider = ({ children }) => {
  // Initialize state from sessionStorage
  const [impersonatedUser, setImpersonatedUser] = useState(() => {
    try {
      const stored = sessionStorage.getItem('impersonatedUser');
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });
  
  const [isImpersonating, setIsImpersonating] = useState(() => {
    try {
      const stored = sessionStorage.getItem('isImpersonating');
      return stored === 'true';
    } catch {
      return false;
    }
  });

  const startImpersonation = (user) => {
    setImpersonatedUser(user);
    setIsImpersonating(true);
    // Persist to sessionStorage
    sessionStorage.setItem('impersonatedUser', JSON.stringify(user));
    sessionStorage.setItem('isImpersonating', 'true');
  };

  const stopImpersonation = () => {
    setImpersonatedUser(null);
    setIsImpersonating(false);
    // Clear from sessionStorage
    sessionStorage.removeItem('impersonatedUser');
    sessionStorage.removeItem('isImpersonating');
  };

  const value = {
    impersonatedUser,
    isImpersonating,
    startImpersonation,
    stopImpersonation
  };

  return (
    <ImpersonationContext.Provider value={value}>
      {children}
    </ImpersonationContext.Provider>
  );
}; 